import { render, staticRenderFns } from "./acknowledgements.vue?vue&type=template&id=08601f0e&"
import script from "./acknowledgements.vue?vue&type=script&lang=js&"
export * from "./acknowledgements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports